import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "backdrop"];

  connect() {
    // Register global handler for toggle button
    document.addEventListener("click", (event) => {
      const toggleButton = event.target.closest(
        '[data-action*="site-sidebar#toggleMobile"]'
      );
      if (toggleButton && !this.element.contains(toggleButton)) {
        event.preventDefault();
        this.toggleMobile();
      }
    });
  }

  toggleMobile() {
    this.panelTarget.classList.toggle("-translate-x-full");
    this.backdropTarget.classList.toggle("hidden");
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full");
    this.backdropTarget.classList.add("hidden");
  }
}
